<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: 'contract',
  routerOption: {
    as_frame: true,
    as_object: true,
  },
};
</script>
